import React, {useState, useContext, useEffect} from "react";
import {azureTokenContext, userInfoContext} from "../App";
import Loading from "./Serving/Loading";
import Contracts from "./Serving/Contracts";
// import { useNavigate } from "react-router-dom";

import * as ApiCalls from "./Serving/ApiCalls";
import UnresolvedValidationsBox from "./Serving/UnresolvedValidationsBox";

import {Container, TextField, Grid} from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {Link} from "react-router-dom";

import "../style/editProfile.css";
import LinkToMainPage from "./Serving/LinkToMainPage";

export default function Profile() {
    const azureToken = useContext(azureTokenContext);
    const [userInfo, setUserInfo] = useContext(userInfoContext);
    const [loading, setLoading] = useState(true);

    // const navigate = useNavigate();

    useEffect(() => {
        const ckeckData = async () => {
            if (userInfo.Id) {
                if (!hasSensitiveInfo()) {
                    await addSensitiveInfoToUserInfo();
                }
                setLoading(false);
            }
        };

        ckeckData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo.Id]);

    const addSensitiveInfoToUserInfo = async () => {
        await ApiCalls.GetUserSensitiveInfo(userInfo, azureToken)
            .then((res) => {
                setUserInfo(() => ({...res}));
            })
            .catch((e) => {
                console.log("error on GetUserSensitiveInfo", e);
                log("ERROR", "Failed GetUserSensitiveInfo " + e.message, "AuthorsPortal", "", "");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const hasSensitiveInfo = () => {
        return userInfo.SocialSecurityNumber || userInfo.BankAccountNumber;
    };

    const styleMUITextFields = {
        backgroundColor: "#f4f4f4c5",
        borderRadius: "8px",

        "& .MuiInputBase-root": {
            pointerEvents: "none", // Disable hover effects
        },
    };

    const styleMUIGrid = {
        padding: "6px",
        backgroundColor: "#e9eeef",
    };

    const log = (level, message, method, workItemId, userRole) => {
        ApiCalls.log(level, message, method, workItemId, userRole, userInfo.Id, azureToken);
    };

    return (
        <>
            {loading ? (
                <Loading/>
            ) : (
                <>
                    <LinkToMainPage/>

                    <Container className="editProfileMainContainer" maxWidth="xl">
                        <Grid className="editProfileSubContainer" container spacing={1}>
                            <Grid item xs={12} md={12} lg={12}>
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "1rem"
                                }}>
                                    <div className="editProfileTitle"
                                         style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                        <div className="iconBackground">
                                            <PersonOutlineOutlinedIcon fontSize="large"/>
                                        </div>
                                        <div className="editProfileTitleText">Profil</div>
                                    </div>
                                    <Link className="goToChangeProfile" to="/editprofile">
                                        Gå til profilendring
                                    </Link>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12}>
                                <UnresolvedValidationsBox/>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                                <Grid container>
                                    <Grid item xs={12} md={11}>
                                        <div className="editProfileColumnHeader">Kontaktinformasjon</div>
                                    </Grid>

                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Navn"
                                            name="Name"
                                            value={userInfo.Name}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="E-post"
                                            name="Email"
                                            value={userInfo.Email}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Mobilnummer"
                                            name="Phone"
                                            value={userInfo.Phone}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Grid container>
                                    <Grid item xs={12} md={11}>
                                        <div className="editProfileColumnHeader">Forfatterprofil</div>
                                    </Grid>
                                    <Grid item xs={12} md={11}>
                                        <div className="imageUploadingDiv">
                                            <div className="imagePreviewDiv">
                                                {userInfo.ImageUrl ? (
                                                    <img className="profileImage" src={userInfo.ImageUrl}
                                                         alt="Profile"></img>
                                                ) : (
                                                    <AccountCircleIcon sx={{fontSize: 48}}/>
                                                )}
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Tittel"
                                            name="Title"
                                            value={userInfo.Title}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Arbeidssted"
                                            name="Employer"
                                            value={userInfo.Employer}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Forfatterpresentasjon"
                                            name="Description"
                                            value={userInfo.Description}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                            multiline
                                            rows={5}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Grid container>
                                    <Grid item xs={12} md={11}>
                                        <div className="editProfileColumnHeader">Honorar</div>
                                    </Grid>

                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Postadresse (privat)"
                                            name="Address"
                                            value={userInfo.Address}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Postnummer"
                                            name="ZipCode"
                                            value={userInfo.ZipCode}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Sted"
                                            name="City"
                                            value={userInfo.City}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Land"
                                            name="Country"
                                            value={userInfo.Country}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Fødselsnummer"
                                            name="SocialSecurityNumber"
                                            value={userInfo.SocialSecurityNumber}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={11} sx={styleMUIGrid}>
                                        <TextField
                                            fullWidth
                                            label="Kontonummer"
                                            name="BankAccountNumber"
                                            value={userInfo.BankAccountNumber}
                                            variant="outlined"
                                            sx={styleMUITextFields}
                                        />
                                    </Grid>
                                    <Contracts/>
                                </Grid>
                            </Grid>

                            {/* Empty grid to make it center aligned */}
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </Container>
                </>
            )}
        </>
    );
}
